module.exports = __webpack_public_path__ + "img/house_20.8f89a9ab.jpg";